/**
 * 图片延迟加载
 * @调用方法:
        1、实例化图片延迟加载函数,并配置相关参数
            let t=new lazyloadImg({
            eleName:'img',//需延迟加载的dom元素标识 类名.a/ID #a/标签 img 默认为img
            data_attribute:'data-original',//实际图片存放的属性名称
            preloadHeight:'screen',//预加载高度 默认为一屏 screen/数字
            excludeWrap:[]//第一次追加待延迟加载的图片时排除此数组下的图片,数组传入的是包裹不延迟加载图片的dom节点#id/.class 的组合
        });
        2、动态创建的html，需手动追加需延迟加载的区块
            t.addDom(动态创建区域的.类名/#id/标签名)
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { accAdd, accSub, addHandler, getClientHeight, getScrollTop } from "./tools";
export var lazyloadImg = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.eleName, eleName = _c === void 0 ? "img" : _c, _d = _b.data_attribute, data_attribute = _d === void 0 ? "data-original" : _d, _e = _b.preloadHeight, preloadHeight = _e === void 0 ? "screen" : _e, _f = _b.scrollWrap, scrollWrap = _f === void 0 ? "window" : _f, _g = _b.excludeWrap, excludeWrap = _g === void 0 ? [] : _g;
    var that = this;
    that.opts = {
        eleName: eleName,
        data_attribute: data_attribute,
        preloadHeight: preloadHeight,
        scrollWrap: scrollWrap,
        excludeWrap: excludeWrap
    };
    that._init();
};
lazyloadImg.prototype = {
    lazyloadImgS: [],
    lazyloadImgTimer: null,
    _init: function () {
        var that = this;
        if (that.opts.excludeWrap.length == 0) {
            // 加载body下所有图片
            that._getLazyloadImg();
        }
        else {
            // 排除excludeWrap下图片，其余添加到队列中
            that._excludeWrapGetImg();
        }
        if (that.opts.scrollWrap != "window") {
            that.scrollWrapEl = document.querySelector(that.opts.scrollWrap);
        }
        else {
            that.scrollWrapEl = document.body;
        }
        addHandler(that.scrollWrapEl, "scroll", function () {
            that.showImg();
        });
    },
    _excludeWrapGetImg: function () {
        // 排除指定dom节点下的img 追加其他img到队列中
        var that = this, imgEl, el = document.body, isExclude = 0;
        for (var i = 0; i < el.querySelectorAll(that.opts.eleName).length; i++) {
            imgEl = el.querySelectorAll(that.opts.eleName)[i];
            // eslint-disable-next-line no-loop-func
            isExclude = that.opts.excludeWrap.filter(function (item, index) {
                return getParents(imgEl, document.querySelector(item));
                // return imgEl.parents(item).length > 0;
            }).length;
            if (!isExclude &&
                imgEl.getAttribute(that.opts.data_attribute) &&
                imgEl.style.display != "none" &&
                imgEl.style.visibility != "hidden" &&
                that.lazyloadImgS.indexOf(imgEl) <= -1) {
                that.lazyloadImgS.push(imgEl);
            }
        }
        if (that.lazyloadImgS.length == 0) {
            return false;
        }
        that.showImg();
    },
    _getLazyloadImg: function (el) {
        // 获取延迟加载图片 追加到lazyloadImgS数组中
        var that = this, imgEl;
        el = !el ? document.body : document.querySelector(el);
        for (var i = 0; i < el.querySelectorAll(that.opts.eleName).length; i++) {
            imgEl = el.querySelectorAll(that.opts.eleName)[i];
            if (imgEl.getAttribute(that.opts.data_attribute) &&
                imgEl.style.display != "none" &&
                imgEl.style.visibility != "hidden" &&
                that.lazyloadImgS.indexOf(imgEl) <= -1) {
                that.lazyloadImgS.push(imgEl);
            }
        }
        if (that.lazyloadImgS.length == 0) {
            return false;
        }
        that.showImg();
    },
    showImg: function () {
        // 判断图片位置 显示图片
        var that = this, imgEl;
        if (that.lazyloadImgTimer) {
            clearTimeout(that.lazyloadImgTimer);
        }
        that.lazyloadImgTimer = setTimeout(function () {
            var winHeight = getClientHeight(), winScrollTop = getScrollTop(that.scrollWrapEl), arr = __spreadArray([], __read(that.lazyloadImgS)), preloadHeight = isNaN(that.opts.preloadHeight)
                ? winHeight
                : that.opts.preloadHeight, imgItemTop;
            if (that.lazyloadImgS.length == 0) {
                return false;
            }
            for (var i = 0; i < that.lazyloadImgS.length; i++) {
                imgEl = that.lazyloadImgS[i];
                imgItemTop =
                    that.opts.scrollWrap == "window"
                        ? imgEl.getBoundingClientRect().top
                        : imgEl.offsetTop;
                if (imgItemTop >= accSub(winScrollTop, preloadHeight) &&
                    imgItemTop < accAdd(accAdd(winHeight, preloadHeight), winScrollTop) &&
                    imgEl.getAttribute(that.opts.data_attribute)) {
                    imgEl.setAttribute("src", imgEl.getAttribute(that.opts.data_attribute));
                    imgEl.removeAttribute(that.opts.data_attribute);
                    arr.splice(arr.indexOf(imgEl), 1);
                }
            }
            that.lazyloadImgS = arr;
        }, 100);
    },
    addDom: function (el) {
        var that = this;
        that._getLazyloadImg(el);
    }
};
function getParents(el, parentSelector) {
    // If no parentSelector defined will bubble up all the way to *document*
    if (parentSelector === undefined) {
        parentSelector = document.body;
    }
    var parents = [];
    var p = el.parentNode;
    while (p !== parentSelector) {
        var o = p;
        parents.push(o);
        p = o.parentNode;
    }
    parents.push(parentSelector); // Push that parentSelector you wanted to stop at
    return parents;
}
